import React from 'react';
import { Input, Rule } from '../../../../store/modules/rules';
import StatementInput from './statement.input';

type IInputsProps = {
  rule: Rule;
  inputs: Input[] | undefined;
  // direction: 'column' | 'row';
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void,
  containerDirection: string;
  contentDirection: string;
};

const StatementInputs = ({
  rule, inputs, containerDirection, contentDirection, onChange,
}: IInputsProps): JSX.Element | null => {
  if (!inputs) return null;
  return (
    <div style={{
      display: 'flex', flexDirection: containerDirection as 'row' | 'column', paddingLeft: '10px', width: '100%',
    }}
    >
      {inputs && inputs.map(
        (i) => (
          <StatementInput
            key={i.name}
            rule={rule}
            input={i}
            onChange={onChange}
            contentDirection={contentDirection}
            containerDirection={containerDirection}
          />
        ),
      )}
    </div>
  );
};

export default StatementInputs;
